import { Suspense } from 'react';
import { PageSpinner } from './PageSpinner';

/** Wraps lazy-loaded page components with a full-page spinner fallback. */
export function Lazy({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<PageSpinner />}>{children}</Suspense>;
}
